import axios from 'axios'
import * as Cookie from '../utils/cookie'
import qs from 'qs'
import Vue from 'vue';
import { Notify } from 'vant';
import vm from "../main"

// 全局注册
Vue.use(Notify);

const studentService = axios.create({ baseURL: process.env.BASE_STUDENT_URL, timeout: 1000 * 60 });
const teacherService = axios.create({ baseURL: process.env.BASE_TEACHER_URL, timeout: 1000 * 60 });

// 请求拦截器
const requestFulfilled = (config) => {

  // 请求进度条
  vm.$toast.loading({
    message: "加载中...",
    forbidClick: true,
    duration: 0,
  });

  config.headers['access-token'] = Cookie.getToken();
  config.headers['Content-Type'] = 'application/json';

  if (config.method.toLowerCase() === 'post' && typeof config.data !== 'string') {
    if (config.headers['Content-Type'] && config.headers['Content-Type'].toLowerCase().includes('application/json')) {
      if (typeof config.data !== 'string') {
        config.data = JSON.stringify(config.data)
      }
    } else {
      if (!config.data) {
        config.data = {};
      }

      if (config.headers['Content-Type'] === 'multipart/form-data') {
        let data = new FormData(); //创建form对象
        Object.keys(config.data).forEach(itm => {
          if (!config.data[itm]) {
            return;
          }
          if (typeof config.data[itm] === "object" && config.data[itm].length) {
            for (let i = 0; i < config.data[itm].length; i++) {
              data.append(`${itm}[${i}]`, config.data[itm][i]);
            }
          } else {
            data.append(itm, config.data[itm]);
          }
        });
        config.data = data;
      } else {
        config.data = qs.stringify(config.data, {
          allowDots: true,
          skipNulls: true
        });
      }
    }
  }
  return config
};
const requestRejected = (error) => {
  vm.$toast.clear();
  return Promise.reject(error)
};


// 响应拦截器
const responseFulfilled = (resp) => {

  vm.$toast.clear();

  if (resp.config.fullResponse) {
    return Promise.resolve(resp);
  }
  if (resp.config.responseType === 'blob' || resp.config.originResponse) {
    return Promise.resolve(resp.data);
  }

  try {
    const data = resp.data;
    // 正常返回
    if (data.status === 0) {
      return Promise.resolve(data.data)
    }

    Notify({
      message: data.message,
      type: 'danger',
    });

    // 缺省处理
    throw new Error('服务器连接超时，请稍后再试')
  } catch (e) {
    return Promise.reject(e)
  }
};
const responseRejected = (error) => {
  vm.$toast.clear();
  Notify({
    message: error.message,
    type: 'danger',
  });
};

// 注入拦截器
studentService.interceptors.request.use(requestFulfilled, requestRejected);
studentService.interceptors.response.use(responseFulfilled, responseRejected);

// 注入拦截器
teacherService.interceptors.request.use(requestFulfilled, requestRejected);
teacherService.interceptors.response.use(responseFulfilled, responseRejected);

var service = {
  "student": studentService,
  "teacher": teacherService
}

export default service


// WEBPACK FOOTER //
// ./src/api/Service.js